export const MINI_STORYBOARD_DURATION_PROFILE_STANDARD = "standard";
export const MINI_STORYBOARD_DURATION_PROFILE_SEEDANCE25 = "seedance25";

const DURATION_LIMITS = Object.freeze({
  [MINI_STORYBOARD_DURATION_PROFILE_STANDARD]: Object.freeze({ min: 4, max: 15 }),
  [MINI_STORYBOARD_DURATION_PROFILE_SEEDANCE25]: Object.freeze({ min: 4, max: 30 }),
});

export const normalizeMiniStoryboardDurationProfile = (value) => (
  value === MINI_STORYBOARD_DURATION_PROFILE_SEEDANCE25
    ? MINI_STORYBOARD_DURATION_PROFILE_SEEDANCE25
    : MINI_STORYBOARD_DURATION_PROFILE_STANDARD
);

export const getMiniStoryboardDurationLimits = (profile) => (
  DURATION_LIMITS[normalizeMiniStoryboardDurationProfile(profile)]
);

const parseDuration = (value, fallback) => {
  const parsed = Number(value);
  if (Number.isFinite(parsed)) return Math.round(parsed);
  const parsedFallback = Number(fallback);
  return Number.isFinite(parsedFallback) ? Math.round(parsedFallback) : 0;
};

/**
 * Build the only two fields involved in editing a storyboard segment's duration.
 * Prompt text, shot metadata and time ranges are deliberately not accepted here.
 */
export const buildMiniStoryboardDurationSaveFields = (
  segment,
  selectedProfile = segment?.durationProfile ?? MINI_STORYBOARD_DURATION_PROFILE_STANDARD,
) => {
  const profile = normalizeMiniStoryboardDurationProfile(selectedProfile);
  const limits = getMiniStoryboardDurationLimits(profile);
  const fallback = limits.max;
  const duration = parseDuration(segment?.durationSeconds, fallback);
  return {
    durationSeconds: Math.max(limits.min, Math.min(limits.max, duration)),
    durationProfile: profile,
  };
};
